import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService, PermissionSpec } from '@/app/core/current-user/current-user.service';

/**
 * Route guard factory: allow only if the current actor holds `spec`.
 * The guarded parent route already enforces authentication + actor load via
 * `[autoLoginPartialRoutesGuard, currentUserGuard]`, so this only gates the permission.
 * Usage: `canActivate: [requirePermission('global.tenants:VIEW')]`.
 */
export function requirePermission(spec: PermissionSpec): CanActivateFn {
    return () => {
        const currentUser = inject(CurrentUserService);
        const router = inject(Router);
        if (currentUser.hasPermission(spec)) return true;
        return router.createUrlTree(['/zabranjen-pristup']);
    };
}
